import { ActionReducer, MetaReducer } from '@ngrx/store';
import * as fromServicegroups from './service-groups.actions';
import { initialState, serviceGroupsAdapter, ServiceGroupsState } from './service-groups.interfaces';

export function reducer(state: ServiceGroupsState, action: fromServicegroups.ServicegroupsAction): ServiceGroupsState {
  switch (action.type) {
    case fromServicegroups.GET_SERVICE_GROUPS_FROM_SERVER_SUCCESS: {
      return {
        ...serviceGroupsAdapter.addMany(action.payload.serviceGroups, state)
      };
    }

    default: {
      return state;
    }
  }
}

export function serviceGroupStateHydration(
  reducer: ActionReducer<ServiceGroupsState>
): ActionReducer<ServiceGroupsState> {
  return function(state: ServiceGroupsState, action: any, metaReducer: string = 'stateHydration'): ServiceGroupsState {
    if (state === undefined) {
      console.log('populate service group state from local storage?');
      let serviceGroups: any = localStorage.getItem('service-groups-state');
      state = serviceGroups ? JSON.parse(serviceGroups) : initialState;
    }
    const newState = reducer(state, action);
    // if (action.feature === 'labourOperations.serviceGroups' && action.triggerStorageSync) {
    //   localStorage.setItem('service-groups-state', JSON.stringify(newState));
    // }

    return newState;
  };
}

export const metaReducers: MetaReducer<ServiceGroupsState>[] = [serviceGroupStateHydration];
